<div class="account-settings">
  <div class="d-flex w-100 bg-white" *ngIf="!isPoaPurchaseRoute">
    <div class="tabs-container m-auto">
      <div [routerLink]="[ACCOUNT_SETTINGS_URL, 'organization']" [ngClass]="{ 'tab-active': isAnOrganizationActiveRoute }">
        {{ "LABELS.ORGANIZATION" | translate }}
      </div>
      <div [routerLink]="companyTabLink" [ngClass]="{ 'tab-active': isCompanyActiveRoute }">
        {{ (companies?.length > 1 ? "LABELS.IMPORTERS_OF_RECORD" : "LABELS.IMPORTER_OF_RECORD") | translate }}
      </div>
      <div [routerLink]="[ACCOUNT_SETTINGS_URL, 'user-details']" [routerLinkActive]="'tab-active'">
        {{ "LABELS.USER_DETAILS" | translate }}
      </div>
      <div [routerLink]="[ACCOUNT_SETTINGS_URL, 'billing-history']" [routerLinkActive]="'tab-active'">
        {{ "MENU.BILLING_HISTORY" | translate }}
      </div>
    </div>
  </div>
  <div class="container page-container">
    <router-outlet></router-outlet>
  </div>
</div>
